var _g, _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _rect3, _rect4, _rect5, _rect6, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrafficFunnelIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 283,
    viewBox: "0 0 316 283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ilmmfyt6wa)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.039,
    y: 8.278,
    width: 291.923,
    height: 258.42,
    rx: 16,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.039,
    y: 11.278,
    width: 285.923,
    height: 252.42,
    rx: 13,
    stroke: "#fff",
    strokeWidth: 6
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.19,
    y: 32.384,
    width: 239.44,
    height: 210.208,
    rx: 8,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.002 59.542V51.03h-3.108v-1.288h7.574v1.288H58.36v8.512h-1.358zm4.806-6.832h1.302v.994c.205-.355.467-.63.784-.826.327-.196.69-.294 1.092-.294.224 0 .434.028.63.084v1.19a2.113 2.113 0 0 0-.672-.112c-.523 0-.961.182-1.316.546-.345.355-.518.821-.518 1.4v3.85h-1.302V52.71zm11.344 6.832h-1.288v-1.4a2.782 2.782 0 0 1-1.05 1.148c-.438.261-.956.392-1.554.392a3.135 3.135 0 0 1-1.68-.476 3.476 3.476 0 0 1-1.204-1.288 3.794 3.794 0 0 1-.434-1.792c0-.644.145-1.237.434-1.778.299-.55.7-.985 1.204-1.302a3.135 3.135 0 0 1 1.68-.476c.597 0 1.115.135 1.554.406.448.261.798.64 1.05 1.134v-1.4h1.288v6.832zm-5.95-3.416a2.304 2.304 0 0 0 1.148 2.016c.355.205.747.308 1.176.308.439 0 .836-.098 1.19-.294.364-.206.644-.486.84-.84.206-.355.308-.752.308-1.19 0-.439-.103-.835-.308-1.19a2.046 2.046 0 0 0-.84-.826 2.332 2.332 0 0 0-1.19-.308 2.305 2.305 0 0 0-2.016 1.148 2.304 2.304 0 0 0-.308 1.176zm8.5-4.102c0-.812.215-1.433.645-1.862.43-.43 1.012-.644 1.75-.644.28 0 .532.028.756.084v1.19a1.915 1.915 0 0 0-.49-.056c-.915 0-1.372.434-1.372 1.302v.672h1.862v1.232H76.99v5.6h-1.288v-5.6h-1.33V52.71h1.33v-.686zm5.073 0c0-.812.215-1.433.644-1.862.43-.43 1.013-.644 1.75-.644.28 0 .532.028.756.084v1.19a1.914 1.914 0 0 0-.49-.056c-.915 0-1.372.434-1.372 1.302v.672h1.862v1.232h-1.862v5.6h-1.288v-5.6h-1.33V52.71h1.33v-.686zm5.823.686v6.832h-1.302V52.71h1.302zm-.644-1.33a.869.869 0 0 1-.616-.252.869.869 0 0 1-.252-.616c0-.233.084-.434.252-.602a.846.846 0 0 1 .616-.266.8.8 0 0 1 .602.266.8.8 0 0 1 .266.602.869.869 0 0 1-.252.616.838.838 0 0 1-.616.252zm5.596 8.302a3.56 3.56 0 0 1-1.792-.462 3.586 3.586 0 0 1-1.274-1.288 3.56 3.56 0 0 1-.462-1.792c0-.663.154-1.265.462-1.806.318-.55.742-.98 1.274-1.288a3.48 3.48 0 0 1 1.792-.476c.523 0 1.018.107 1.484.322.467.214.85.513 1.148.896.308.383.5.807.574 1.274H93.44c-.093-.364-.322-.663-.686-.896a2.082 2.082 0 0 0-1.204-.364c-.42 0-.802.102-1.148.308a2.3 2.3 0 0 0-.826.84 2.419 2.419 0 0 0-.294 1.19c0 .43.098.821.294 1.176.206.345.48.62.826.826.346.205.728.308 1.148.308.458 0 .864-.122 1.218-.364.364-.252.593-.57.686-.952h1.302a2.673 2.673 0 0 1-.56 1.316 3.169 3.169 0 0 1-1.148.91 3.54 3.54 0 0 1-1.498.322zm13.582-9.94v1.288h-4.27v2.842h3.808v1.288h-3.808v4.382h-1.358v-9.8h5.628zm6.068 8.596c-.215.43-.513.76-.896.994-.373.233-.807.35-1.302.35-.877 0-1.573-.276-2.086-.826-.513-.55-.77-1.297-.77-2.24V52.71h1.302v3.766c0 .597.168 1.078.504 1.442.336.355.784.532 1.344.532.569 0 1.027-.178 1.372-.532.355-.364.532-.845.532-1.442l.014-3.766h1.288v6.832H111.2v-1.204zm4.382-4.396c.215-.439.514-.775.896-1.008a2.407 2.407 0 0 1 1.316-.364c.878 0 1.573.275 2.086.826.514.55.77 1.297.77 2.24v3.906h-1.302v-3.766c0-.598-.168-1.074-.504-1.428-.336-.364-.784-.546-1.344-.546-.569 0-1.031.182-1.386.546-.345.355-.518.83-.518 1.428h-.014v3.766h-1.288V52.71h1.288v1.232zm8.149 0c.215-.439.513-.775.896-1.008a2.404 2.404 0 0 1 1.316-.364c.877 0 1.573.275 2.086.826.513.55.77 1.297.77 2.24v3.906h-1.302v-3.766c0-.598-.168-1.074-.504-1.428-.336-.364-.784-.546-1.344-.546-.569 0-1.031.182-1.386.546-.345.355-.518.83-.518 1.428h-.014v3.766h-1.288V52.71h1.288v1.232zm9.996 5.74a3.485 3.485 0 0 1-1.778-.462 3.445 3.445 0 0 1-1.26-1.302 3.665 3.665 0 0 1-.462-1.82c0-.644.154-1.232.462-1.764a3.37 3.37 0 0 1 1.26-1.274 3.38 3.38 0 0 1 1.764-.476 3.21 3.21 0 0 1 1.652.434c.504.29.901.686 1.19 1.19.299.504.448 1.069.448 1.694l-.014.504h-5.53c.056.644.29 1.166.7 1.568.411.392.938.588 1.582.588.486 0 .906-.112 1.26-.336.355-.224.574-.518.658-.882h1.274c-.121.71-.48 1.279-1.078 1.708-.588.42-1.297.63-2.128.63zm1.904-4.27a1.826 1.826 0 0 0-.616-1.232c-.364-.327-.812-.49-1.344-.49-.55 0-1.017.154-1.4.462-.382.298-.634.718-.756 1.26h4.116zm4.055 4.13h-1.302v-9.8h1.302v9.8z",
    fill: "#8C8C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218.871 162.127H90.949l22.967 26.725h81.247l23.708-26.725z",
    fill: "#CCEBF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDDA5F",
    d: "M68.196 77.919h173.427v26.725H68.196z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#009DDB",
    d: "M79.32 106.156h150.674v26.725H79.32z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#7AD1F4",
    d: "M89.433 134.394h131.461v26.221H89.433z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5F5FB",
    d: "M113.196 190.364h83.427v26.221h-83.427z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 131.33,
    y: 86.263,
    width: 47.298,
    height: 3.31,
    rx: 1.655,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 131.33,
    y: 114.33,
    width: 47.298,
    height: 3.31,
    rx: 1.655,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 131.33,
    y: 142.398,
    width: 47.298,
    height: 3.31,
    rx: 1.655,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 131.33,
    y: 170.465,
    width: 47.298,
    height: 3.31,
    rx: 1.655,
    fill: "#909090"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 131.33,
    y: 198.532,
    width: 47.298,
    height: 3.31,
    rx: 1.655,
    fill: "#909090"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ilmmfyt6wa",
    x: 0.039,
    y: 0.278,
    width: 315.923,
    height: 282.42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_497_2185"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_497_2185",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficFunnelIllustration);
export default __webpack_public_path__ + "static/media/traffic-funnel-illustration.60a4f4e1b0e0cb306e10cccbca8ca9ac.svg";
export { ForwardRef as ReactComponent };